import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import AssignJobForm from './form'

function AssignJobDialog ({ open, onClose, target }) {
  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Assign Job to Target'
      size='large'
    >
      {open ? (
        <AssignJobForm target={target} onCancel={onClose} />
      ) : null}
    </SydModal>
  )
}

AssignJobDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  target: PropTypes.object
}

export default AssignJobDialog
